"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var data_store_1 = __importDefault(require("../../data-store"));
var storable_data_service_1 = __importDefault(require("../../storable-data-service"));
var vehicle_types_service_1 = __importDefault(require("./vehicle-types-service"));
var VehicleTypesApi = /** @class */ (function () {
    function VehicleTypesApi(session) {
        this.vehicleTypesStore = new data_store_1.default();
        this.vehicleTypesService = new vehicle_types_service_1.default(session);
        this.storableDataService = new storable_data_service_1.default(this.vehicleTypesStore);
    }
    VehicleTypesApi.prototype.load = function (id, options) {
        var _this = this;
        return this.storableDataService.load('load', function () { return _this.vehicleTypesService.load(id); }, id, options);
    };
    VehicleTypesApi.prototype.loadAll = function (options) {
        var _this = this;
        return this.storableDataService.loadAll('loadAll', function () { return _this.vehicleTypesService.loadAll(); }, options);
    };
    VehicleTypesApi.prototype.delete = function (id) {
        var _this = this;
        return this.storableDataService.delete('delete', function () { return _this.vehicleTypesService.delete(id); }, id);
    };
    VehicleTypesApi.prototype.update = function (id, vehicleData) {
        var _this = this;
        return this.storableDataService.modify('update', function () { return _this.vehicleTypesService.update(id, vehicleData); });
    };
    VehicleTypesApi.prototype.create = function (vehicleData) {
        var _this = this;
        return this.storableDataService.modify('create', function () { return _this.vehicleTypesService.create(vehicleData); });
    };
    VehicleTypesApi.prototype.get = function (id) {
        return this.vehicleTypesStore.get(id);
    };
    VehicleTypesApi.prototype.getAll = function () {
        return this.vehicleTypesStore.getAll();
    };
    return VehicleTypesApi;
}());
exports.default = VehicleTypesApi;
//# sourceMappingURL=vehicle-types-api.js.map